import env from 'env/env';
import { Link } from 'react-router-dom';
import { trackProductPromotionClick } from 'analytics/product-promotion-click-tracking';
import { PromotionV2 } from 'constants/products';

export const makeDSPromo = (promotion: PromotionV2) => {
  const {
    discount,
    groups,
    hidden,
    promotionDescription,
    promotionId,
    promotionTypeCode,
    promotionType,
    promoPath,
    ...rest
  } = promotion;

  const promoDescriptionWithFallback = promotionDescription || `Unknown promotion: ${promotionId}`;

  return {
    ...rest,
    discount,
    groups,
    hidden,
    promotionDescription: promoDescriptionWithFallback,
    promotionId,
    promotionTypeCode: promotionTypeCode ?? promotionType,
    promotionType,
    linkProps: {
      component: Link,
      to: `${env.root}${promoPath}`,
      onClick: () => trackProductPromotionClick(promoDescriptionWithFallback),
    },
  };
};
